import { StarIcon } from "components/common/Icons/StarIcon";

interface StarsProps {
    score: number;
    count?: number;
}

export const Stars = ({ score, count = 5 }: StarsProps) => (
    <div className="grid" style={{ gridTemplateColumns: `repeat(${count}, minmax(0, 1fr))` }}>
        {Array.from(Array(count).keys()).map((i) => (
            <StarIcon key={i} className={i < score ? "fill-black" : ""} />
        ))}
    </div>
);
